export default {
  title : 'Catalog Builder',
  nav: {
    catalogs : 'Catalogs',
    account : 'My account',
    logout : 'Logout'
  },
  catalog: {
    title: 'Your catalogs',
    new : 'New catalog'
  },
  builder: {
    title: 'Builder',
  },
  account: {
    title: 'My account'
  },
  common : {
    view : 'Consult',
    edit : 'Modify',
    delete : 'Delete'
  }
}
